var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"reserve-selection":"","row-key":"item_id","url":_vm.tableUrl,"setting":_vm.setting,"fixed-row-action":"","hooks":{
      beforeSearch: _vm.beforeSearch,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }